/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { WalletTransfersResponse } from '../../models/wallet-transfers-response';

export interface BookingControllerGetWalletTransfers$Params {
  for_gmg_wallet: boolean;
  from_date?: string;
  to_date?: string;
  status_id?: number;
  from_amount?: number;
  to_amount?: number;
  limit: number;
  skip: number;
}

export function bookingControllerGetWalletTransfers(http: HttpClient, rootUrl: string, params: BookingControllerGetWalletTransfers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WalletTransfersResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerGetWalletTransfers.PATH, 'get');
  if (params) {
    rb.query('for_gmg_wallet', params.for_gmg_wallet, {});
    rb.query('from_date', params.from_date, {});
    rb.query('to_date', params.to_date, {});
    rb.query('status_id', params.status_id, {});
    rb.query('from_amount', params.from_amount, {});
    rb.query('to_amount', params.to_amount, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: WalletTransfersResponse;
      }>;
    })
  );
}

bookingControllerGetWalletTransfers.PATH = '/booking/wallet/transfer';
